/**
 * Subjects de permisos usados por el menú lateral.
 * Los de Trazabilidad son inferidos del nombre del menú hasta que backend confirme los definitivos.
 */
export const MENU_SUBJECTS = {
  assignments: 'assignments',
  curingTransfer: 'curing-transfer',
  curing: 'curing',
  seedBackoffice: 'seed-backoffice',
  seedManagement: 'seed-management',
  shipments: 'shipments',
  users: 'users',
  roles: 'roles',
  seedUnagro: 'seed-unagro',
} as const;
